module.exports = __webpack_public_path__ + "img/1.18_Russian_road_sign.38b95233.svg";